import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { OTP_SEND, OTP_VERIFIED_FORGOT } from '../../../constant-value';
import api from '../../../services/axiosConfig';

const ForgotOTP = () => {
  const { mobile } = useParams();
  const navigate = useNavigate();
  const [cooldown, setCooldown] = useState(0);
  const [otpValues, setOtpValues] = useState(['', '', '', '']);
  const [errorShake, setErrorShake] = useState(false);
  const inputsRef = useRef([]);

  // تابع ارسال OTP
  const reSendOtp = () => {
    if (cooldown > 0) return;
    api.post(`/${OTP_SEND}`, { phoneNumber: mobile })
      .then(res => {
        if (res.data.isSuccess) {
          message(res.data.message, 'success');
          setTimer();
        } else {
          message(res.data.message, 'warn');
        }
      })
      .catch(err => {
        message("تا پایان زمان منتظر بمانید", "warn");
        setTimer();
      });
  };

  const reSendHandler = (e) => {
    e.preventDefault();
    reSendOtp();
  };

  // تایمر ارسال مجدد
  const setTimer = () => {
    setCooldown(180);
    const timer = setInterval(() => {
      setCooldown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    setTimer();
    inputsRef.current[0]?.focus();
  }, []);

  // مدیریت ورودی‌ها
  const handleInput = (e, idx) => {
    const val = e.target.value.replace(/\D/, '');
    const newOtp = [...otpValues];
    newOtp[idx] = val;
    setOtpValues(newOtp);
    if (val && idx < 3) {
      inputsRef.current[idx + 1]?.focus();
    }
  };

  const handleKeyDown = (e, idx) => {
    if (e.key === 'Backspace' && !otpValues[idx] && idx > 0) {
      inputsRef.current[idx - 1]?.focus();
    }
  };

  // تایید OTP
  const continueHandler = (e) => {
    e.preventDefault();
    const otpCode = otpValues.join('');
    api.post(`/${OTP_VERIFIED_FORGOT}`, { phoneNumber: mobile, otpCode })
      .then(res => {
        if (res.data.isSuccess) {
          message(res.data.message, 'success');
          navigate('/forgot-change/' + mobile);
        } else {
          message(res.data.message, 'warn');
          setOtpValues(['', '', '', '']);
          setErrorShake(true);
          setTimeout(() => setErrorShake(false), 400);
          inputsRef.current[0]?.focus();
        }
      })
      .catch(err => console.log(err));
  };

  const backHandler = (e) => {
    e.preventDefault();
    navigate(-1);
  };

  const message = (msg, type) => {
    if (type === 'warn') toast.warning(msg, { autoClose: 1500 });
    else toast.success(msg, { autoClose: 1500 });
  };

  return (
    <div className="container-fluid vh-100 bg-light"> <div className="row h-100 justify-content-center align-items-center"> <div className="col-md-5 col-lg-4"> <div className="card shadow-sm border-0 rounded-4"> <div className="card-body p-4 p-md-5"> <div className="text-center mb-4"> <h2 className="h3 fw-bold text-primary mb-3">گام دوم - تأیید شماره همراه</h2> <div className="alert alert-info py-2"> <i className="bi bi-info-circle-fill me-2"></i>
      کد ۴ رقمی به شماره <span className="fw-bold">{mobile}</span> ارسال گردید </div> </div>
      {/* OTP Inputs */}
      <div className={`otp-wrapper d-flex gap-2 mb-4 ${errorShake ? 'shake' : ''}`}>
        {[0, 1, 2, 3].map((i) => (
          <input
            key={i}
            ref={(el) => (inputsRef.current[i] = el)}
            type="text"
            maxLength="1"
            inputMode="numeric"
            className="otp-input"
            value={otpValues[i]}
            onChange={(e) => handleInput(e, i)}
            onKeyDown={(e) => handleKeyDown(e, i)}
          />
        ))}
      </div>
      <small className="text-muted d-block text-center mb-3">
        لطفاً کد ۴ رقمی را وارد نمایید
      </small>

      <div className="d-grid gap-2 mb-3">
        <button className="btn btn-primary py-2 rounded-3 fw-bold" onClick={continueHandler}>
          <i className="bi bi-check-circle-fill me-2"></i>
          تأیید و ادامه
        </button>
      </div>

      <div className="d-flex justify-content-between align-items-center">
        <button className="btn btn-outline-secondary rounded-3 px-3" onClick={backHandler}>
          <i className="bi bi-arrow-right-circle-fill me-2"></i>
          اصلاح شماره
        </button>

        <button
          onClick={reSendHandler}
          disabled={cooldown > 0}
          className={`btn ${cooldown > 0 ? 'btn-outline-warning' : 'btn-warning'} rounded-3 px-3`}
        >
          {cooldown > 0 ? (
            <>
              <i className="bi bi-clock-history me-2"></i>
              صبر کنید ({cooldown} ثانیه)
            </>
          ) : (
            <>
              <i className="bi bi-send-fill me-2"></i>
              ارسال مجدد کد
            </>
          )}
        </button>
      </div>
    </div>
    </div>
    </div>
    </div>

      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.0/font/bootstrap-icons.css" />

      <style>{`
      .otp-wrapper {
        direction: ltr !important;
        display: flex !important;
        justify-content: center !important;
        flex-direction: row !important;
      }
      .otp-input {
        width: 55px;
        height: 58px;
        border-radius: 12px;
        border: 1px solid #ced4da;
        font-size: 1.6rem;
        letter-spacing: 0.5rem;
        text-align: center !important;
        direction: ltr !important;
        transition: all 0.2s;
      }
      @media (max-width: 480px) {
        .otp-input {
          width: 48px;
          height: 52px;
          font-size: 1.6rem;
        }
      }
      .otp-input:focus {
        outline: none;
        border-color: #0d6efd;
        box-shadow: 0 0 4px rgba(13,110,253,.35);
      }

      /* Shake Animation */
      .shake {
        animation: shakeAnim .4s ease;
      }
      @keyframes shakeAnim {
        0% { transform: translateX(0); }
        20% { transform: translateX(-5px); }
        40% { transform: translateX(5px); }
        60% { transform: translateX(-4px); }
        80% { transform: translateX(4px); }
        100% { transform: translateX(0); }
      }
    `}</style>
    </div>
  );
};

export default ForgotOTP;
